<top-banner variant="small"></top-banner>
<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">

        <div class="card-body">
          <card-section-header
            title="Site Form Report"
            icon="fas fa-list">
          </card-section-header>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>From <span class="text-danger">*</span></label>
                <p-calendar class="form-control" [(ngModel)]="fromDate" dateFormat="dd/mm/yy"></p-calendar>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>To <span class="text-danger">*</span></label>
                <p-calendar class="form-control" [(ngModel)]="toDate" dateFormat="dd/mm/yy"></p-calendar>
              </div>
            </div>

            <div class="col-md-6" *ngIf="formsArray.length">
              <div class="form-group">
                <label>Site Form <span class="text-danger">*</span></label>
                <p-multiSelect
                  class="form-control"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="selectedForms"
                  [options]="formsArray"
                  defaultLabel="Select Form"
                  optionLabel="label"
                  filter="true"
                ></p-multiSelect>
              </div>
            </div>

            <div class="col-md-6" *ngIf="sitesArray.length">
              <div class="form-group">
                <label>Site</label>
                <p-multiSelect
                  class="form-control"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="selectedSites"
                  [options]="sitesArray"
                  defaultLabel="Select Site"
                  optionLabel="label"
                  filter="true"
                ></p-multiSelect>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>Selecting multiple Forms or Sites will result in one document per selected combination</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button type="button" (click)="submitForm()" class="btn btn-success btn-round">
                <strong>Generate Report</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
